export default "__VITE_ASSET__03868f39__"